import type WorkflowDefinitionCriteriaTypeModel from '@src/service/model/workflow/WorkflowDefinitionCriteriaTypeModel'

import Repository from './base'

export const WORKFLOW_DEFINITION_CRITERIA_TYPE_TABLE_NAME =
  'workflowDefinitionCriteriaType'
export class WorkflowDefinitionCriteriaTypeRepository extends Repository<WorkflowDefinitionCriteriaTypeModel> {}
